import Storable from '@/mixins/storable';

export default {
  mixins: [Storable],
  props: {
    editorStorePath: {
      type: Array,
      required: true,
    },
  },
  computed: {
    storePath() {
      return this.editorStorePath;
    },
  },
};
